// Banner.js
import React, { useState } from "react";
import "./PageBanner.css"; 

const images = [

    "images/banners/collage.jpg",
  ];
  

function PageBanner() {
    const [currentImageIndex] = useState(0);

  return (
    <div
      className="pagebanner"
      style={{
        backgroundImage: `url(${images[currentImageIndex]})`,
      }}
    >
        <div class="bkg-slide-1"></div>
        <div class="bkg-slide-2"></div>
    </div>
  );
};

export default PageBanner;
